import { useLocation } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { ARCH_PROFILE_LICENSE_DETAILS, ARCHITECT_PROFILE_DOCS_DETAILS, ARCHITECT_PROFILE_PERSONAL_DETAILS } from '../UserManagement.const';
import { useEffect, useState } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { getDropdownOptions } from '../../../../services/modulesServices/userManagement.api';
import { entityDocumentDataForArchitect, getArcInitialData } from '../UserMangement.controller';
import HeaderComponent from '../../../../components/header/Header.component';
import { useTranslation } from 'react-i18next';
import { ARCHITECT_PROFILE_VALIDATION } from '../../../../utils/formikValidation/FormikValidation';
import Loading from '../../../../components/portalComponents/Loading.component';
import GenericFormCard from '../../../../components/moduleCommonFormik/GenericFormCard.component';
import GenericHeader from '../../../../components/moduleCommonFormik/GenericHeader';

export const ArchitectDetailsPage = () => {
    const location = useLocation();
    const empData = location?.state?.data.Employees?.[0] ?? null;
    const { t } = useTranslation();
    const [documents, setDocuments] = useState<any>([]);
    const [dropdownData, setDropdownData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const formik = useFormik<any>({
        initialValues: {
            isUpdatable: true
        },
        validationSchema: ARCHITECT_PROFILE_VALIDATION,
        onSubmit: (value: any) => {}
    });

    const { setValues } = formik;

    const setInitialData = async () => {
        try {
            setIsLoading(true);
            const initData = await getArcInitialData(empData, dropdownData);
            const documentData = await entityDocumentDataForArchitect(empData.documents);
            setDocuments(documentData);
            setValues((prev: any) => ({ ...prev, ...initData, uuid: empData.uuid }));
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (empData?.uuid && dropdownData) {
            setInitialData();
        }
    }, [empData, dropdownData]);

    useEffect(() => {
        getDropdownOptions()
            .then(res => {
                setDropdownData(res);
            })
            .catch(err => {});
    }, []);

    return (
        <>
            {!!isLoading && <Loading />}
            <HeaderComponent />
            <div className='employee-creation-container bg-light m-auto px-5 py-4 row'>
                <GenericHeader text={t('ARCHITECT_ENGINEER_DETAILS', 'Architect/Engineer Details')} bottomSubText={`${t('ARCHITECT_ID', 'Architect Id')}- ${empData?.code}`} />
                <Card className='card_border'>
                    <FormikProvider value={formik}>
                        <Card.Body>
                            {ARCHITECT_PROFILE_PERSONAL_DETAILS.map((val: any, id: number) => (
                                <GenericFormCard key={id} {...val} isEditable={false} dropdownOptions={dropdownData} module='usermanagement' hideAddressCheckbox={true} />
                            ))}
                            {ARCH_PROFILE_LICENSE_DETAILS.map((val: any, id: number) => (
                                <GenericFormCard key={id} {...val} isEditable={false} dropdownOptions={dropdownData} module='usermanagement' />
                            ))}
                            {ARCHITECT_PROFILE_DOCS_DETAILS.map((val: any, id: number) => (
                                <GenericFormCard key={id} {...val} />
                            ))}
                        </Card.Body>
                    </FormikProvider>
                </Card>
            </div>
        </>
    );
};
